import { render } from "./DetailDokumen.vue?vue&type=template&id=4de85754"
import script from "./DetailDokumen.vue?vue&type=script&lang=js"
export * from "./DetailDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__